export enum COMPANY_LOGO_SIZE {
    small = 'small',
    medium = 'medium',
    large = 'large'
}
